import { render, staticRenderFns } from "./EditMortgage.vue?vue&type=template&id=ce776424"
import script from "./EditMortgage.vue?vue&type=script&lang=ts"
export * from "./EditMortgage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports